import { create } from "zustand";
import type { AccessSession } from "../lib/access";

/**
 * The access session the SPA learned at boot (`/api/access/session`), held
 * once so the Shell can say WHERE it is connected without a second fetch
 * (remote-node program N3 half 2, 2026-09-08). App.tsx writes it; the
 * sidebar's node badge and the unreachable banner read it. `via` is what the
 * gate decided: `loopback` (this machine), `token` (a Bearer header — the
 * desktop app in client mode, the CLI), `session` (a browser's cookie).
 */
interface AccessSessionState {
	session: AccessSession | null;
	setSession: (session: AccessSession | null) => void;
}

export const useAccessSessionStore = create<AccessSessionState>((set) => ({
	session: null,
	setSession: (session) => set({ session }),
}));

export function useAccessSession(): AccessSession | null {
	return useAccessSessionStore((s) => s.session);
}

/** True when this UI is served by a node on ANOTHER machine — a credential
 *  admitted it. Loopback and "unknown" (an unreachable server at boot) are
 *  not remote: no badge, no remote wording. */
export function isRemoteSession(session: AccessSession | null | undefined): boolean {
	return !!session && (session.via === "token" || session.via === "session");
}
